import React from "react";
import { Link } from "react-router-dom";
import PageHeader from "../../../components/common/PageHeader";

/**
 * Takeaway Header Component
 * Displays the page header with title and subtitle
 */
const TakeawayHeader = () => {
  return (
    <PageHeader
      showBackButton={true}
      backTo={-1}
      title="Takeaway Orders"
      subtitle={
        <span className="flex items-center gap-2">
          <span className="inline-block w-2 h-2 bg-green-500 rounded-full"></span>
          Create and manage takeaway orders
        </span>
      }
      action={
        <Link
          to="/takeaway/history"
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-indigo-600 border border-indigo-200 rounded-lg hover:bg-indigo-50 transition-colors"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          History
        </Link>
      }
    />
  );
};

export default TakeawayHeader;
